import useRequest from '@/composables/use-request'

const baseUrl = '/api'
const { get, post } = useRequest()

// 登出请求
export async function logout() {
  return post<any>(`${baseUrl}/cas/logout`)
}

// 没有token时获取token和用户信息
export async function getRdxToken<T>() {
  return post<T>(`${baseUrl}/blade-auth/cas/token?grant_type=cas`)
}

// 刷新 token 仅依赖浏览器自动携带的 HttpOnly 会话 Cookie；refresh_token 不会下发给前端。
export async function refreshSession<T>() {
  return post<T>(`${baseUrl}/blade-auth/cas/refresh`, undefined, {
    skipAuthRenewal: true,
    skipRequestDedup: true,
  })
}
// 获取用户权限组
export async function getPermissionGroup(userId?: string) {
  return get<string[]>(`${baseUrl}/blade-auth/cas/getPermissionGroupList`, { userId })
}
// 从bo端直接登录后获取用户信息
export async function getTokenObject<T>() {
  return get<T>(`${baseUrl}/blade-auth/cas/getTokenObject`)
}
// tgc续期请求
export async function loginTgc<T>() {
  return get<T>('/api/casApi/go-cas/anon/login/tgc', {}, { skipRequestDedup: true })
}

export async function callbackWithoutRedirect<T>(ticket: string) {
  return get<T>(`${baseUrl}/cas/callbackWithoutRedirect?ticket=${encodeURIComponent(ticket.trim())}`, {}, { skipRequestDedup: true })
}
